import { Box, IconButton, Tooltip } from '@material-ui/core';
import {
  DeleteOutlined,
  EditOutlined,
  VisibilityOutlined
} from '@material-ui/icons';
import { Action, Resource, WithPermissions } from 'components/Authorization';
import DeleteDialog from 'components/DeleteDialog';
import i18n from 'i18n';
import { FormData } from 'pages/assignments/formData';
import { useOpStates } from 'pages/assignments/utils';
import { FunctionComponent } from 'react';

interface ActionButtonsI {
  isAdmin: boolean;
  currentLnsUser: $Lns.User;
  assignment: FormData;
  onHandleView: (assignmentGuid: string) => void;
  onHandleEdit: (assignmentGuid: string) => void;
  onHandleDelete: (assignmentGuid: string) => void;
}

const ActionButtons: FunctionComponent<ActionButtonsI> = ({
  isAdmin,
  currentLnsUser,
  assignment,
  onHandleView,
  onHandleEdit,
  onHandleDelete
}: ActionButtonsI) => {
  const { guid, title } = assignment;

  const { canViewEdit, canDelete } = useOpStates(
    assignment,
    currentLnsUser,
    isAdmin
  );

  if (!guid) return <p>{i18n.t('badData')}</p>;

  return (
    <Box display="flex">
      <Box>
        <Tooltip
          title={i18n.t('pages.assignments.tooltip.view').toString()}
          aria-label="view"
        >
          <IconButton
            size="small"
            color="secondary"
            onClick={() => onHandleView(guid)}
          >
            <VisibilityOutlined />
          </IconButton>
        </Tooltip>
      </Box>
      <WithPermissions
        lnsResource={Resource.TASK}
        lnsAction={Action.EDIT}
        disable={!canViewEdit}
      >
        <Box>
          <Tooltip
            title={i18n.t('pages.assignments.tooltip.edit').toString()}
            aria-label="view"
          >
            <IconButton size="small" onClick={() => onHandleEdit(guid)}>
              <EditOutlined color="secondary" />
            </IconButton>
          </Tooltip>
        </Box>
      </WithPermissions>
      <WithPermissions
        lnsResource={Resource.TASK}
        lnsAction={Action.DELETE}
        disable={!canDelete}
      >
        <DeleteDialog
          size="small"
          lnsResource={Resource.TASK}
          lnsAction={Action.DELETE}
          onDelete={() => onHandleDelete(guid)}
          color="secondary"
          icon={<DeleteOutlined color="secondary" />}
          tooltip={i18n.t('pages.assignments.tooltip.delete')}
          target={title}
          targetDeleteTitle={i18n.t('deleteDialog.assignments.title')}
          targetDeletePrompt={i18n.t('deleteDialog.assignments.prompt')}
          targetDeleteWarning={i18n.t('deleteDialog.assignments.warning')}
          btnDisabled={!canDelete}
        />
      </WithPermissions>
    </Box>
  );
};

export default ActionButtons;
